import axios from "axios"

const api = axios.create({
    baseURL: "https://api.tehlil.com",
    headers:{
        "Content-Type":"application/json"
    }
});


// Ajouter le token automatiquement

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if(token){
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
})


//Intercepter les erreurs 401 (token expiré)
api.interceptors.response.use((response) => response, (error) => {
    if(error.response && error.response.status === 401){
        localStorage.removeItem("token")
        window.location.href="/"; //Rediger
    }
    return Promise.reject(error);
})

export default api;